define(
  'app/views/city_selector_view',[
    'app/setup', 'app/models/city_area_selector',
    'app/views/suburb_selector_view', 'app/views/area_selector_view' ,'app/views/region_selector_view'
  ], function(
    takhfifan, cityAreaSelector, suburbSelectorView, areaSelectorView, regionSelectorView
  ) {

  takhfifan.CitySelectorView = Backbone.View.extend({

    initialize: function() {
      this.setViewCity(this.model.get('city'));
    },

    events: {
      'keyup input' : 'updateCity',
      'change input' : 'updateCity'
    },

    setViewCity: function(city) {
      this.$('span .value').first().text(city);
      this.$('select>option[value="' + city + '"]').prop('selected', true);
    },

    updateCity: function(event) {
      var city = $(event.target).val();
      this.setViewCity(city);
      this.model.set('city', city);
    }

  });

  $('.tkh-city-area-selector').each(function(){
    var $_this = $(this);
    var $citySelector = $_this.find('.tkh-city-select').first();

    var cityAreaSelector = new takhfifan.CityAreaSelector({
      city: $citySelector.data('city')
    });

    new takhfifan.AreaSelectorView({
      el: $_this.find('.tkh-areas').first(),
      model: cityAreaSelector
    });

    new takhfifan.SuburbSelectorView({
      el: $_this.find('.tkh-suburbs').first(),
      model: cityAreaSelector
    });

    new takhfifan.CitySelectorView({
      el: $_this.find('.tkh-cities').first(),
      model: cityAreaSelector
    });

    new takhfifan.RegionSelectorView({
      el: $_this.find('.tkh-regions').first(),
      model: cityAreaSelector
    });

  });

});

